module.exports = __webpack_public_path__ + "f2fc2de32cc5810a392e325492b0ac2b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-princess-king.svg
// module id = 476
// module chunks = 0